export default {
	"capacityPool": {
		"partnerName": "ขึ้นกับส่วน",
		"plateType": "ประเภทป้ายทะเบียน",
		"hasGps": "มีจีพีเอสหรือไม่",
		"capacityInfo": "ข้อมูลขีดความสามารถ",
		"addCapacity": "ขีดความสามารถใหม่",
		"routeType": "ประเภทของสายยานพาหนะ"
	},
	"motorcade": {
		"name": "ชื่อกลุ่มยานพาหนะ",
		"driverNum": "จำนวนพนักงานขับรถ",
		"vehicleNum": "จำนวนยานพาหนะ",
		"partnerName": "ผู้ขนส่งที่เป็นคู่ค้า",
		"capatainName": "หัวหน้ากลุ่มยานพาหนะ",
		"addMotorcade": "สร้างกลุ่มยานพาหนะใหม่",
		"motorcadeInfo": "ข้อมูลกลุ่มยานพาหนะ",
		"requirement": "ข้อกำหนดในการบำรุงรักษายานพาหนะ",
		"depreciation": "ข้อกำหนดค่าเสื่อมราคา",
		"maintenance": "ข้อกำหนดการบำรุงรักษา",
		"insurance": "ข้อกำหนดการประกันภัย",
		"vehicleCertificate": "ข้อกำหนดเอกสารยานพาหนะ",
		"pictureAttachment": "การแนบรูปถ่าย",
		"certificateRequirement": "ข้อกำหนดหมายเลขประจำตัวพนักงานขับรถ",
		"driverCertificateIsRequired": "ต้องระบุหมายเลขประจำตัวพนักงานขับรถ",
		"vehicleCertificateisRequired": "ต้องมีชื่อใบรับรองยานพาหนะ",
		"certificateNameNorNull": "ข้อกำหนดใบรับรองยานพาหนะ ไม่สามารถเว้นว่างชื่อใบรับรองได้!",
		"dricerNameNorNull": "ใบรับรองของพนักงานขับรถกำหนดให้ไม่สามารถเว้นว่างชื่อใบรับรองได้!"
	},
	"ourdriver": {
		"drivingAgeMonth": "ช่วงอายุการขับขี่",
		"driverName": "ชื่อพนักงานขับรถ",
		"drivingAge": "อายุการขับขี่",
		"zeroMonth": "0 เดือน",
		"driverLicenseType": "ประเภทของใบอนุญาตขับขี่",
		"defaultVehiclePlate": "ยานพาหนะเริ่มต้น",
		"baseWage": "ค่าจ้างพื้นฐาน",
		"newDriver": "เพิ่มพนักงานขับรถใหม่",
		"licenseDate": "วันที่ได้รับครั้งแรก",
		"defaultVehicleNoTips": "กรุณาเลือกหมายเลขป้ายทะเบียน",
		"score": "คะแนนใบอนุญาตขับขี่",
		"importFailed": "นำเข้าไม่สำเร็จ",
		"driverInfo": "ข้อมูลพนักงานขับรถ",
		"startAndEndDateTips": "วันหมดอายุของใบรับรองต้องมากกว่าวันหมดอายุของใบรับรอง"
	},
	"ourvehicle": {
		"refuelRecord": "บันทึกการเติมน้ำมัน / การชาร์จ",
		"vehicleAge": "อายุรถ",
		"vehicleValue": "ค่าเดิม",
		"netValue": "มูลค่าสุทธิ",
		"equipmentPosition": "การหาตำแหน่งอุปกรณ์",
		"newVehicle": "ยานพาหนะใหม่",
		"plateLicenseColor": "สีแผ่นป้ายทะเบียน",
		"vehicleRegistDate": "วันที่จดทะเบียนยานพาหนะ",
		"gpsFee": "ค่าธรรมเนียมจีพีเอสรายปี",
		"importCar": "นำเข้ายานพาหนะ",
		"importRefuel": "นำเข้าบันทึกน้ำมันเชื้อเพลิง",
		"inputCarNoTips": "กรุณากรอกเลขแผ่นป้ายทะเบียนให้ถูกต้อง",
		"carNoOrVehicleTypeCodeTips": "เลขแผ่นป้ายทะเบียน รุ่นไม่ผ่านการตรวจ",
		"year": "ปี",
		"month": "เดือนที่คำนวณระยะทาง",
		"aYear": "1 ปี",
		"noLocationInfo": "ยังไม่มีข้อมูลสถานที่",
		"certificateAdmin": "การจัดการเอกสาร",
		"reach": "ถึง",
		"certificateFee": "ค่าตรวจประจำปี",
		"fuelPerson": "เติมน้ำมัน/ชาร์จ",
		"fuelDate": "วันที่เติมน้ำมัน/ชาร์จ",
		"fuelVolumn": "ความจุในการเติมน้ำมัน/การชาร์จ (ลิตร/ระดับ)",
		"oilType": "ประเภทน้ำมัน",
		"fuelMoney": "ค่าเติม/ชาร์จ",
		"payType": "วิธีการชำระเงิน",
		"maintenanManage": "การจัดการบำรุงรักษา",
		"maintenancePlan": "แผนการบำรุงรักษา",
		"nextMaintenanceMileage": "ระยะบำรุงรักษาถัดไป",
		"nextMaintenanceTime": "วันที่บำรุงรักษาครั้งถัดไป",
		"maintenancePeriod": "รอบการบำรุงรักษา",
		"upkeepCost": "ค่าธรรมเนียมการบำรุงรักษาทั้งหมด",
		"repairCost": "ค่าบำรุงรักษาทั้งหมด",
		"repairAndUpkeepCost": "การบำรุงรักษาทั้งหมด",
		"addMaintenanManage": "บันทึกการบำรุงรักษา",
		"maintenanceType": "ประเภท",
		"maintenanceDt": "วันที่บำรุงรักษา",
		"remark": "อธิบาย",
		"amount": "ค่าบำรุงรักษา",
		"repairMan": "ช่างซ่อม",
		"depreciationOfAssets": "ค่าเสื่อมราคาของสินทรัพย์",
		"premiumPeriod": "ระยะเวลาของเศษซาก (เดือน)",
		"salvage": "อัตราคงเหลือ",
		"inputRangeTips": "กรุณากรอกตัวเลขตั้งแต่ 0 ถึง 1.0000",
		"depreciationValue": "ค่าเสื่อมราคาสะสม",
		"residualValue": "มูลค่าคงเหลือ",
		"insuranceLog": "บันทึกการประกันภัย",
		"insuranceType": "ประเภทของประกันภัย",
		"premium": "ค่าธรรมเนียมการประกันภัย",
		"mileageLog": "บันทึกระยะทาง",
		"mileage": "ระยะทางรวม",
		"currentMonthMileage": "ระยะทางประจำเดือน",
		"monthMileageInfo": "ระยะทางรายเดือน",
		"monthMileage": "ระยะทาง (กม.)",
		"totalMileage": "ระยะทางเมื่อสิ้นสุดเดือน (กม.)",
		"mileageJournal": "บันทึกระยะทาง",
		"methodCode": "วิธีการคำนวณ",
		"distance": "ระยะทาง (กม.)",
		"violationRecords": "บันทึกการละเมิด",
		"violationContent": "สินค้าผิดกฎหมาย",
		"violationAddress": "สถานที่",
		"violationTime": "เวลาที่ผิดกฏหมาย",
		"pointsDeducted": "การหักเงิน",
		"penalty": "ค่าปรับ",
		"driverName": "พนักงานขับรถที่ไม่ชอบด้วยกฎหมาย",
		"checkPersonName": "ผู้ยืนยัน",
		"regularLine": "เส้นทางปกติ",
		"line": "เส้นทาง",
		"capacityPool": "ขีดความสามารถของกลุ่ม",
		"certificateInfo": "ข้อมูลบุคคล",
		"violationInfo": "ข้อมูลผิดกฎหมาย",
		"curingInfo": "ข้อมูลการบำรุงรักษา",
		"max500": "น้อยกว่า 500 คำ",
		"pleaseAddAttachments": "กรุณาเพิ่มเอกสารแนบ",
		"certificateFeeTips": "กรอกจำนวนเงินค่าตรวจสอบประจำปีไม่ถูกต้อง กรุณากรอกค่าระหว่าง 0 ถึง 9999999.99 โดยมีทศนิยมสองตำแหน่ง",
		"isTrunkTips": "เมื่อประเภทสายยานพาหนะเป็นรถบรรทุก เมืองต้นทางและเมืองปลายทางต้องไม่เหมือนกัน!",
		"currentMileageTips": "ระยะทางปัจจุบันต้องไม่เกินระยะทางทั้งหมด",
		"dateTips": "วันหมดอายุต้องมากกว่าวันที่มีผลบังคับใช้",
		"oldValueInputError": "กรอกค่าเดิมไม่ถูกต้อง กรุณากรอกค่าระหว่าง 0 ถึง 9999999.99 โดยมีทศนิยมสองตำแหน่ง",
		"gpsFeeTips": "กรอกค่าธรรมเนียมจีพีเอสรายปีไม่ถูกต้อง กรุณากรอกค่าระหว่าง 0 ~ 9999999.99 โดยมีทศนิยมสองตำแหน่ง",
		"premiumPeriodTips": "กรอกวันหมดอายุไม่ถูกต้อง กรุณากรอกจำนวนเต็มระหว่าง 0 ถึง 1000",
		"salvageTips": "กรอกค่าคงเหลือไม่ถูกต้อง กรุณากรอกทศนิยมหรือจำนวนเต็มระหว่าง 0 ถึง 1 และทศนิยมสี่ตำแหน่ง",
		"maintenancePeriodTips": "กรอกข้อมูลรอบการบำรุงรักษาไม่ถูกต้อว กรุณากรอกจำนวนเต็มบวก"
	},
	"partner": {
		"quotationTemplate": "รูปแบบเอกสารข้อมูลราคา",
		"businessRelations": "ความสัมพันธ์",
		"partnerType": "ออนไลน์หรือไม่",
		"offer": "ต้องมีเอกสารข้อมูลราคา",
		"nLike": "ชื่อคู่ค้า/ชื่อย่อ/รหัส",
		"partnerName": "ชื่อ",
		"billingObject": "บุคคลที่เรียกเก็บเงิน",
		"comments": "รายละเอียดเกี่ยวกับธุรกิจ",
		"partnerCode": "หมายเลข",
		"billingTips": "กรุณาเลือกผู้ที่เรียกเก็บเงิน",
		"receiptDtSize": "เวลาที่ได้รับ",
		"receiptDt": "วันปิดรับสินค้าประจำเดือน",
		"outerCode": "รหัสภายนอก",
		"outerSourceCode": "แหล่งภายนอก",
		"companyGroup": "บริษัทในเครือ",
		"day": "วัน",
		"number": "หมายเลข",
		"batchWorking": "อนุญาตให้จัดส่งแบบเทกอง",
		"belongToUser": "เป็นของผู้ใช้",
		"heIsyours": "เขาเป็นของท่าน",
		"heUseThisPlatform": "บริษัทใช้แพลตฟอร์มนี้เช่นกัน",
		"heNotUseThisPlatform": "บริษัทไม่ได้ใช้แพลตฟอร์มนี้",
		"partnerNameTips": "กรอกชื่อบริษัท/ตัวย่อ",
		"partnerCodeTips": "กรุณากรอกรหัส (สูงสุด 20 ตัวอักษร)",
		"shortNameTips": "กรุณากรอกชื่อย่อ (สูงสุด 50 ตัวอักษร)",
		"salesman": "พนักงานขาย",
		"existential": "มีอยู่",
		"application": "ยื่นขอ",
		"saveAddNext": "กรุณากรอกและบันทึกข้อมูลการติดต่อที่สำเร็จก่อนเพิ่มข้อมูลถัดไป",
		"partnerCodeNotNullTips": "ต้องระบุหมายเลข",
		"acceptTips": "ท่านแน่ใจว่าจะยอมรับหรือไม่?",
		"partnerInvitedTips": "กรุณาคัดลอกที่อยู่ส่งคำเชิญแก่คู่ค้าของท่าน",
		"copyLink": "คัดลอกลิ๊งก์",
		"inviteTips": "เชิญเข้าร่วมแพลตฟอร์ม"
	},
	"product": {
		"productNameAndCode": "ชื่อกลุ่ม\\ชื่อย่อกลุ่ม\\รหัสกลุ่ม",
		"superiorProduct": "สินค้าที่เหนือกว่า",
		"level": "ชั้น",
		"createChild": "สร้างสินค้าย่อยใหม่",
		"addNewProduct": "สร้าง กลุ่มค่าธรรมเนียม/ส่วนลด ใหม่",
		"groupCode": "รหัสกลุ่ม",
		"groupName": "ชื่อกลุ่ม",
		"groupShortName": "ชื่อย่อกลุ่ม",
		"enterGroupCode": "กรอกรหัสกลุ่ม",
		"enterGroupName": "กรอกชื่อกลุ่ม",
		"enterGroupShortName": "กรอกชื่อย่อกลุ่ม",
		"rangeValueMustBe": "ค่าพิกัดต้องเป็น",
		"numberBetween": "ระหว่างตัวเลข!",
		"maxAndminTips": "【ค่าขีดจำกัดสูงสุด】ต้องมากกว่าหรือเท่ากับ 【ค่าขีดจำกัดต่ำสุด】!",
		"defaultValueWithinRange": "ค่าเริ่มต้นต้องเป็นตัวเลขในช่วงของค่าต่างๆ!",
		"commaErrorGroupCode": "ไม่สามารถใส่อักขระพิเศษเช่นจุลภาค (“ , “) ในรหัสกลุ่ม",
		"createSuccess": "สร้างกลุ่มค่าธรรมเนียม/ส่วนลดเรียบร้อยแล้ว",
		"groupCodeOrNameExists": "มีรหัสกลุ่มหรือชื่อกลุ่มนี้อยู่แล้ว",
	},
	"serviceItem": {
		"createNew": "สร้างค่าธรรมเนียม/ส่วนลดใหม่",
		"itemCode": "รหัสรายการ",
		"itemName": "ชื่อรายการ",
		"step": "ขั้นตอน",
		"selectStep": "เลือกขั้นตอน",
		"commaErrorItemCode": "ไม่สามารถใส่อักขระพิเศษเช่นจุลภาค (“ , “) ในรหัสรายการ",
		"createSuccess": "สร้างค่าธรรมเนียม/ส่วนลดเรียบร้อยแล้ว",
		"enterShortName": "กรอกชื่อย่อ",
		"enterItemCode": "กรอกรหัสรายการ",
		"enterItemName": "กรอกชื่อรายการ",
		"selectBelongTo": "เลือกขึ้นกับส่วน",
		"itemCodeOrNameExists": "มีรหัสรายการหรือชื่อรายการนี้อยู่แล้ว",
	},
	"project": {
		"nameOrNoTips": "ชื่อ/รหัสโครงการ",
		"projectName": "ชื่อ",
		"serviceContent": "รายการค่าธรรมเนียม/ส่วนลด",
		"addService": "เพิ่มรายการค่าธรรมเนียม/ส่วนลด",
		"essentialService": "บริการที่จำเป็น",
		"pleaseSelectMotherboard": "กรุณาเลือกแบบฟอร์มใบเสนอราคา",
		"orderContent": "เนื้อหาของเอกสาร",
		"addNewItem": "โครงการใหม่",
		"sureAgree": "ท่านแน่ใจว่าเห็นชอบใช่หรือไม่?",
		"agreed": "อนุมัติแล้ว!",
		"suspendTips": "ท่านแน่ใจว่าจะหยุดใช่หรือไม่?",
		"toBeConfirmedTips": "เริ่มต้นโครงการออนไลน์นี้แล้ว รออีกฝ่ายยืนยัน!",
		"inputTips": "กรุณากรอกตัวเลขที่มากกว่า 0 โดยมีทศนิยมไม่เกินสองตำแหน่ง!",
		"coldStorage": "การทำความเย็น",
		"minWeightTips": "น้ำหนักขั้นต่ำคือตัวเลขระหว่าง 0.001 ถึง 99999.999!",
		"maxWeightTips": "น้ำหนักสูงสุดคือตัวเลขระหว่าง 0.001 ถึง 999999.999!",
		"minVolumeTips": "ปริมาณขั้นต่ำคือตัวเลขระหว่าง 0.001 ถึง 999.999!",
		"maxVolumeTips": "ปริมาณสูงสุดคือตัวเลขระหว่าง 0.001 ถึง 999.999!",
		"minGoodsValueTips": "ค่าต่ำสุดของค่าที่ประกาศคือตัวเลขระหว่าง 0.00 ถึง 9999999.99!",
		"maxGoodsValueTips": "ค่าสูงสุดของค่าที่ประกาศคือตัวเลขระหว่าง 0.00 ถึง 9999999.99!",
		"minPackingQtyTips": "จำนวนบรรจุภัณฑ์ขั้นต่ำคือตัวเลขระหว่าง 1 ถึง 999999999!",
		"maxPackingQtyTips": "จำนวนบรรจุภัณฑ์สูงสุดคือตัวเลขระหว่าง 1 ถึง 999999999!",
		"maxDistributionOrder": "คำสั่งจัดส่งสูงสุด",
		"betweenMaxiAndMini": "ค่าเริ่มต้นต้องเป็นตัวเลขระหว่างค่าสูงสุดและค่าต่ำสุด!",
		"areYouSureToSave": "ท่านแน่ใจว่าจะบันทึกหรือไม่?",
		"noMotherboardInfo": "ข้อมูลรูปแบบไม่เป็นที่ทราบ",
		"multipleMotherboardInfo": "ข้อมูลรูปแบบซ้ำซ้อน",
		"noServiceInfo": "ข้อมูลบริการไม่เป็นที่ทราบ",
		"multipleServiceInfo": "ข้อมูลบริการซ้ำซ้อน",
		"duplicateSurchargeDiscount": "มีรายการค่าธรรมเนียม/ส่วนลดนี้อยู่แล้ว",
	},
	"site": {
		"stationNoOrName": "รหัส/ชื่อสถานที่",
		"ownSite": "สถานที่ของตนเอง",
		"sharedSite": "สถานที่สำหรับการใช้งานร่วมกัน",
		"stationOwn": "ทรัพย์สินสำหรับการใช้งานร่วมกัน",
		"locationStatus": "การกำหนดตำแหน่งบนแผนที่",
		"stationNo": "รหัสสถานที่",
		"stationName": "ชื่อสถานที่",
		"province": "จังหวัด",
		"city": "เมือง",
		"district": "เขต/อำเภอ",
		"siteStaff": "บุคลากรประจำสถานที่",
		"operators": "ผู้ปฏิบัติงาน",
		"pleaseSelectOperators": "กรุณาเลือกพนักงาน",
		"addSite": "สร้างสถานที่ใหม่",
		"pleaseSiteName": "กรุณากรอกชื่อสถานที่",
		"stationTypeTips": "กรุณาเลือกประเภทสถานที่",
		"entrepotCreate": "เป็นศูนย์กระจายสินค้าหรือไม่",
		"channelNum": "จำนวนประตูโหลดสินค้า",
		"pleaseInputChannelNum": "กรุณากรอกจำนวนประตูโหลดสินค้า",
		"pleaseInputSiteNo": "กรุณากรอกรหัสสถานที่",
		"priority": "ลำดับความสำคัญ",
		"loadSpeed": "ความเร็วในการบรรทุกและการขนถ่าย",
		"loadSpeedUnit": "ความเร็วในการขนถ่าย (กก./นาที)",
		"workTime": "กรอบเวลาทำงาน",
		"limitLength": "ความยาวสูงสุดของรุ่น",
		"limitLengthUnit": "ความยาวสูงสุดของรุ่น (ม.)",
		"checkTime": "เวลาส่งมอบ (นาที)",
		"locked": "ล็อคหรือไม่",
		"addrRange": "ช่วงตำแหน่ง (ม.)",
		"stationAddress": "ที่อยู่",
		"yes": "มี",
		"no": "ไม่มี",
		"salesman": "พนักงานขาย",
		"alreadyExists": "มีแล้ว",
		"has": "ใช่",
		"addressChange": "ข้อมูลที่อยู่ถูกเปลี่ยนแปลง กรุณา [กำหนดสถานที่ใหม่] ก่อนยื่น!",
		"location": "สถานที่",
		"reposition": "กำหนดสถานที่ใหม่",
		"inputAddressTips": "กรุณากรอกข้อมูล จังหวัด เมือง และที่อยู่!",
		"failedToLocate": "การหาตำแหน่งไม่สำเร็จ กรุณายืนยันข้อมูลที่อยู่และลองอีกครั้ง!"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/our/our.js